import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ml-64 min-h-screen bg-gray-50" }
const _hoisted_2 = { class: "px-8 py-6" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "px-8 py-6" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" }
const _hoisted_6 = { class: "bg-white rounded-lg shadow-sm p-6 border border-gray-200" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "ml-4" }
const _hoisted_9 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_10 = { class: "bg-white rounded-lg shadow-sm p-6 border border-gray-200" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_14 = { class: "bg-white rounded-lg shadow-sm p-6 border border-gray-200" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "ml-4" }
const _hoisted_17 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_18 = { class: "bg-white rounded-lg shadow-sm border border-gray-200" }
const _hoisted_19 = { class: "overflow-x-auto" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_23 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_25 = { class: "text-sm text-gray-900" }
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_27 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_28 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_29 = {
  key: 2,
  class: "text-sm text-gray-500"
}
const _hoisted_30 = {
  key: 3,
  class: "text-sm text-gray-500"
}
const _hoisted_31 = {
  key: 4,
  class: "text-sm text-gray-500"
}
const _hoisted_32 = {
  key: 5,
  class: "text-sm text-gray-500"
}
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_35 = { class: "text-sm text-gray-500" }
const _hoisted_36 = { class: "px-6 py-4" }
const _hoisted_37 = { class: "text-sm text-gray-900 max-w-xs" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_40 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_41 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_42 = { class: "text-sm text-gray-500" }
const _hoisted_43 = { class: "px-6 py-4 border-t border-gray-200" }
const _hoisted_44 = { class: "flex items-center justify-between" }
const _hoisted_45 = { class: "text-sm text-gray-700" }
const _hoisted_46 = { class: "font-medium" }
const _hoisted_47 = { class: "font-medium" }
const _hoisted_48 = { class: "flex items-center space-x-2" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_51 = { class: "relative" }
const _hoisted_52 = { class: "relative" }
const _hoisted_53 = { class: "md:col-span-2" }
const _hoisted_54 = { class: "relative" }
const _hoisted_55 = {
  key: 0,
  class: "bg-gray-50 rounded-lg p-4"
}
const _hoisted_56 = { class: "space-y-2 text-sm text-gray-600" }
const _hoisted_57 = { class: "flex justify-between" }
const _hoisted_58 = { class: "font-medium" }
const _hoisted_59 = { class: "flex justify-end space-x-3" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_62 = { class: "space-y-4" }
const _hoisted_63 = { class: "bg-gray-50 rounded-lg p-4" }
const _hoisted_64 = { class: "bg-white border border-gray-200 rounded-md p-4 overflow-auto max-h-96" }
const _hoisted_65 = { class: "text-sm text-gray-800 whitespace-pre-wrap font-mono" }
const _hoisted_66 = { class: "flex justify-end" }

import { onMounted, ref, reactive } from 'vue';
import { useRequestStore } from '@/store/requests';
import { useNotificationStore } from '@/store/notifications';
import { formatCharge } from '@/utils/chargeHandler';
import { useAuthStore  } from '@/store/auth';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'kyc_val',
  setup(__props) {

const requestStore = useRequestStore();
const notificationStore = useNotificationStore();
const showModal = ref(false);
const showResponseDetails = ref('');
const loading = ref(false);
const showResponse = ref(false);
const authStore = useAuthStore();

const formData = reactive({
  entityType: 0,
  identifierType: '',
  identifier: '',
});

onMounted(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'local') {
    requestStore.fetchAdminKYCValidations(1);
  } else {
    requestStore.fetchKYCValidations(1);
  }
});

async function submitValidation() {
  loading.value = true;
  if ((formData.entityType !== 0 && formData.entityType !== 1) || !formData.identifierType || !formData.identifier) {
    notificationStore.showError('Validation Error', 'Please fill in all required fields');
    loading.value = false;
    return;
  }

  try {
    await requestStore.validateKYCRequest(
      formData.identifier,
      formData.entityType,
      formData.identifierType,
    );
    loading.value = false;
    formData.entityType = 0;
    formData.identifier = '';
    formData.identifierType = '';
    loadPage(1);
    notificationStore.showSuccess('KYC Validation', 'KYC validation completed successfully');
  } catch (error) {
    loading.value = false;
    console.error('KYC validation failed:', error);
    notificationStore.showError('Validation Failed', 'Failed to complete KYC validation. Please try again.');
  }
}

function loadPage(page: number) {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'local') {
    requestStore.fetchAdminKYCValidations(page);
  } else {
    requestStore.fetchKYCValidations(page);
  }
}

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
  return formatted;
}

function formatEntityType(entityType: string) {
  return entityType.charAt(0).toUpperCase() + entityType.slice(1);
}

function formatIdentifierType(identifierType: string) {
  return identifierType.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function maskIdentifier(identifier: string, identifierType: string) {
  if (!identifier) return '';

  if (identifierType.toLowerCase() === 'nin' && identifier.length > 4) {
    return identifier.substring(0, 2) + '*'.repeat(identifier.length - 4) + identifier.substring(identifier.length - 2);
  }

  if (identifier.length > 6) {
    return identifier.substring(0, 3) + '*'.repeat(identifier.length - 6) + identifier.substring(identifier.length - 3);
  }

  return identifier;
}

function getStatusBadgeClass(status: string) {
  switch (status.toLowerCase()) {
    case 'success':
    case 'completed':
    case 'verified':
      return 'bg-green-100 text-green-800 border border-green-200';
    case 'failed':
    case 'error':
    case 'rejected':
      return 'bg-red-100 text-red-800 border border-red-200';
    case 'pending':
    case 'processing':
    case 'under_review':
      return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
    default:
      return 'bg-gray-100 text-gray-800 border border-gray-200';
  }
}

function formatResponse(response: string) {
  if (!response) return 'No response data';

  try {
    // Try to parse as JSON to format nicely
    const parsed = JSON.parse(response);
    if (typeof parsed === 'object') {
      return JSON.stringify(parsed, null, 2);
    }
    return response;
  } catch {
    // If not JSON, return as-is
    return response;
  }
}

function getSuccessCount() {
  return requestStore.kycValidationResults?.filter((req) => req.status.toLowerCase() === 'success' || req.status.toLowerCase() === 'completed' || req.status.toLowerCase() === 'verified').length;
}

function getFailedCount() {
  return requestStore.kycValidationResults?.filter((req) => req.status.toLowerCase() === 'failed' || req.status.toLowerCase() === 'error' || req.status.toLowerCase() === 'rejected').length;
}

function getTotalCharges() {
  return requestStore.kycValidationResults?.reduce((total, req) => total + requestStore.getParsedCharge(req.charge), 0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("div", null, [
              _createElementVNode("h1", { class: "text-2xl font-bold text-green-800" }, "KYC Validation"),
              _createElementVNode("p", { class: "mt-2 text-sm text-gray-600" }, "Perform comprehensive KYC validations and view validation history")
            ], -1)),
            (_unref(authStore).hasPermissions('run_validations', 'public'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true)),
                  class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]"
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    class: "w-5 h-5 mr-2",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 4v16m8-8H4"
                    })
                  ], -1),
                  _createTextVNode(" Validate KYC ", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-shrink-0 bg-green-100 rounded-lg p-3" }, [
                _createElementVNode("svg", {
                  class: "w-6 h-6 text-green-600",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Successful Validations", -1)),
                _createElementVNode("p", _hoisted_9, _toDisplayString(getSuccessCount()), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-shrink-0 bg-red-100 rounded-lg p-3" }, [
                _createElementVNode("svg", {
                  class: "w-6 h-6 text-red-600",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Failed Validations", -1)),
                _createElementVNode("p", _hoisted_13, _toDisplayString(getFailedCount()), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-shrink-0 bg-green-100 rounded-lg p-3" }, [
                _createElementVNode("svg", {
                  class: "w-6 h-6 text-green-600",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm font-medium text-gray-600" }, "Total Charges", -1)),
                _createElementVNode("p", _hoisted_17, "UGX " + _toDisplayString(getTotalCharges()), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"px-6 py-4 border-b border-gray-200\"><div class=\"flex items-center justify-between\"><h3 class=\"text-lg font-medium text-gray-900\">Validation History</h3><div class=\"flex items-center space-x-3\"><label class=\"sr-only\">Filter by status</label><select aria-label=\"Filter by status\" class=\"border border-gray-300 rounded-md px-3 py-2 text-sm\"><option>All Status</option><option>Successful</option><option>Failed</option></select><label class=\"sr-only\">Search validations</label><input type=\"text\" aria-label=\"Search validations\" placeholder=\"Search...\" class=\"border border-gray-300 rounded-md px-3 py-2 text-sm\"></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
              _cache[17] || (_cache[17] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Entity Type "),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Identifier"),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Identifier Type "),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status"),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Vendor ID"),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Response"),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Charge"),
                  _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(requestStore).kycValidationResults, (request) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: request.id,
                    class: "hover:bg-gray-50 transition-colors duration-150"
                  }, [
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(formatEntityType(request.entityType)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(maskIdentifier(request.identifier, request.identifierType)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      (request.identifierType ===
                    'ii_drivers_license_permit_number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Driver's License Permit"))
                        : _createCommentVNode("", true),
                      (request.identifierType ===
                    'ii_refugee_number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Refugee Number"))
                        : _createCommentVNode("", true),
                      (request.identifierType ===
                    'ii_passport_number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Passport Number"))
                        : _createCommentVNode("", true),
                      (request.identifierType ===
                    'ii_tax_identification_number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Tax Identification Number"))
                        : _createCommentVNode("", true),
                      (request.identifierType ===
                    'ii_nssf_number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, "NSSF Number"))
                        : _createCommentVNode("", true),
                      (request.identifierType ===
                    'ii_registration_certificate_number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Business Certification Number"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("span", {
                        class: _normalizeClass([getStatusBadgeClass(request.status), "inline-flex px-2 py-1 text-xs font-semibold rounded-full"])
                      }, _toDisplayString(request.status), 3)
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(request.vendorId?.String || 'N/A'), 1)
                    ]),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (showResponseDetails.value = request.response),
                          class: "text-green-600 hover:text-green-800 font-medium",
                          title: "Click to view full response"
                        }, " View Response ", 8, _hoisted_38)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(requestStore).getFormattedCharge(request.charge)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(formatDate(request.createdAt)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[18] || (_cache[18] = _createTextVNode(" Showing ", -1)),
                _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(requestStore).pagination.currentPage), 1),
                _cache[19] || (_cache[19] = _createTextVNode(" of ", -1)),
                _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(requestStore).pagination.totalPages), 1),
                _cache[20] || (_cache[20] = _createTextVNode(" pages ", -1))
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("button", {
                  class: "px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50",
                  disabled: _unref(requestStore).pagination.currentPage <= 1
                }, " Previous ", 8, _hoisted_49),
                _createElementVNode("button", {
                  class: "px-3 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (loadPage(_unref(requestStore).pagination.nextPage)))
                }, " Next ")
              ])
            ])
          ])
        ])
      ]),
      _createVNode(Modal, {
        show: showModal.value,
        title: "KYC Validation",
        size: "max-w-4xl",
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showModal.value = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitValidation, ["prevent"]),
            class: "space-y-6"
          }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", null, [
                _cache[24] || (_cache[24] = _createElementVNode("label", {
                  for: "entityType",
                  class: "block text-sm font-medium text-gray-700 mb-2"
                }, "Entity Type", -1)),
                _createElementVNode("div", _hoisted_51, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-gray-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      })
                    ])
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.entityType) = $event)),
                    id: "entityType",
                    required: "",
                    class: "block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-indigo-500"
                  }, _cache[22] || (_cache[22] = [
                    _createElementVNode("option", { value: "" }, "Select entity type", -1),
                    _createElementVNode("option", { value: "0" }, "Individual", -1),
                    _createElementVNode("option", { value: "1" }, "NonIndividual", -1)
                  ]), 512), [
                    [_vModelSelect, formData.entityType]
                  ])
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, "Select the type of entity to validate", -1))
              ]),
              _createElementVNode("div", null, [
                _cache[28] || (_cache[28] = _createElementVNode("label", {
                  for: "identifierType",
                  class: "block text-sm font-medium text-gray-700 mb-2"
                }, "Identifier Type", -1)),
                _createElementVNode("div", _hoisted_52, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-gray-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                      })
                    ])
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.identifierType) = $event)),
                    id: "identifierType",
                    required: "",
                    class: "block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  }, _cache[26] || (_cache[26] = [
                    _createElementVNode("option", { value: "" }, "Select identifier type", -1),
                    _createElementVNode("option", { value: "ii_refugee_number" }, "Refugee ID", -1),
                    _createElementVNode("option", { value: "ii_passport_number" }, "Passport", -1),
                    _createElementVNode("option", { value: "ii_drivers_license_permit_number" }, "Driver's License", -1),
                    _createElementVNode("option", { value: "ii_registration_certificate_number" }, "Business Registration", -1),
                    _createElementVNode("option", { value: "ii_tax_identification_number" }, "Tax ID", -1),
                    _createElementVNode("option", { value: "ii_nssf_number" }, "NSSF Number", -1)
                  ]), 512), [
                    [_vModelSelect, formData.identifierType]
                  ])
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, "Select the type of identifier to validate", -1))
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  for: "identifier",
                  class: "block text-sm font-medium text-gray-700 mb-2"
                }, "Identifier", -1)),
                _createElementVNode("div", _hoisted_54, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-gray-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      })
                    ])
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.identifier) = $event)),
                    id: "identifier",
                    type: "text",
                    class: "block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500",
                    placeholder: "Enter identifier",
                    required: ""
                  }, null, 512), [
                    [_vModelText, formData.identifier]
                  ])
                ]),
                _cache[32] || (_cache[32] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, "Enter the identifier value for validation", -1))
              ])
            ]),
            (showResponse.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-900 mb-2" }, "Validation Details", -1)),
                  _createElementVNode("div", _hoisted_56, [
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex justify-between" }, [
                      _createElementVNode("span", null, "Service:"),
                      _createElementVNode("span", { class: "font-medium" }, "KYC Validation")
                    ], -1)),
                    _createElementVNode("div", _hoisted_57, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", null, "Cost:", -1)),
                      _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(requestStore).kycValidationResponse.cost), 1)
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "flex justify-between" }, [
                      _createElementVNode("span", null, "Processing Time:"),
                      _createElementVNode("span", { class: "font-medium" }, "500 milliseconds")
                    ], -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "bg-green-50 border border-green-200 rounded-lg p-4" }, [
              _createElementVNode("div", { class: "flex" }, [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("svg", {
                    class: "h-5 w-5 text-green-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ])
                ]),
                _createElementVNode("div", { class: "ml-3" }, [
                  _createElementVNode("h3", { class: "text-sm font-medium text-green-800" }, "KYC Validation"),
                  _createElementVNode("div", { class: "mt-2 text-sm text-green-700" }, [
                    _createElementVNode("p", null, "This service performs comprehensive KYC validation against multiple databases and provides detailed verification results.")
                  ])
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showModal.value = false)),
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
              }, " Cancel "),
              _createElementVNode("button", {
                type: "submit",
                disabled: loading.value,
                class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_61, _cache[37] || (_cache[37] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(loading.value ? 'Validating...' : 'Validate KYC'), 1)
              ], 8, _hoisted_60)
            ])
          ], 32)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(Modal, {
        show: !!showResponseDetails.value,
        title: "Response Details",
        size: "max-w-4xl",
        onClose: _cache[8] || (_cache[8] = ($event: any) => (showResponseDetails.value = ''))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _cache[39] || (_cache[39] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-900 mb-2" }, "API Response", -1)),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("pre", _hoisted_65, _toDisplayString(formatResponse(showResponseDetails.value)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (showResponseDetails.value = '')),
                class: "px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
              }, " Close ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})